module.exports = __webpack_public_path__ + "img/Condominio_das_Americas_Alameda.fd586913.jpg";